<template>
    <span class="injury-badge" :class="{ 'injury-badge--dense': dense }" :style="badgeStyle">{{ label }}</span>
</template>

<script>
import { injurySeverity } from '@/utils/Injuries'

export default {
    name: 'InjuryBadge',
    props: {
        complexity: {
            type: String,
            default: null,
        },
        dense: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        label(vm = this) {
            return vm.injuryComplexityLabel(vm.complexity)
        },
        badgeStyle(vm = this) {
            const severity = injurySeverity(vm.complexity)
            return {
                background: severity.bg,
                borderColor: severity.border,
                color: severity.color,
            }
        },
    },
}
</script>

<style scoped>
.injury-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid;
    border-radius: 5px;
    font-size: 10px;
    font-weight: 700;
    padding: 3px 10px;
    white-space: nowrap;
}

.injury-badge--dense {
    border: none;
    border-radius: 4px;
    font-weight: 600;
    padding: 2px 6px;
    flex-shrink: 0;
}
</style>
